import * as classNames from 'classnames';
import style from './LocaleSelection.less';
import * as React from 'react';

interface LocaleSelectionProps extends React.ClassAttributes<any> {
    data: any;
    disabled?: boolean;
    label?: string;
    onChange: (data: any) => void;
    selection?: any;
}

export class LocaleSelection extends React.Component<LocaleSelectionProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    onChange(event: any, key: string): void {
        const checked: boolean = event.target.checked;
        const selection: any = { ...this.props.selection || {} };
        selection[key] = checked;
        this.props.onChange(selection);
    }

    render(): JSX.Element {
        return (
            <div className={style.selection}>
                {this.props.label &&
                    <div className={style.label}>
                        {this.props.label}
                    </div>
                }
                {this.renderLocales()}
            </div>
        );
    }

    renderLocales(): JSX.Element[] {
        const locales: any = this.props.data || {};
        const selection: any = this.props.selection || {};

        return Object.keys(locales).map((key: string, index: number) => {
            const disabled: boolean = this.props.disabled
                || (Object.values(selection).filter((value: boolean) => value).length === 1 && selection[key]);
            const locale: string = locales[key] || '';

            return (
                <div className={style.locale} key={`locale-${index}`}>
                    <input
                        key={`input-selection-${key}`}
                        id={`input-selection-${key}`}
                        type='checkbox'
                        checked={selection[key] || false}
                        disabled={disabled}
                        onChange={(event: any) => this.onChange(event, key)}
                    />
                    <label
                        className={classNames(style.flag, style[`flag-${key}`])}
                        key={`label-selection-${key}`}
                        htmlFor={`input-selection-${key}`}
                    >
                        {locale}
                    </label>
                </div>
            );
        });
    }
}
